import moment from "moment";

export function getFormattedTime(current: Date, input: Date): string {
  const currentMoment = moment(current);
  const inputMoment = moment(input);
  if (currentMoment.isSame(inputMoment, "day")) {
    return inputMoment.format("h:mm A");
  }
  return inputMoment.format("DD/MM/YY, h:mm A");
}

export function getCountDownString(time1: Date, time2: Date): string {
  const diffTime = time2.getTime() - time1.getTime();
  const duration = moment.duration(diffTime, "milliseconds");
  return moment.utc(duration.as("milliseconds")).format("H:mm:ss");
}

export function getEmailDateString(date: Date): string {
  const dateMoment = moment(date);
  return `${dateMoment.format("ddd, MMM D, YYYY")} at ${dateMoment.format(
    "h:mm A"
  )}`;
}
